module.exports = __webpack_public_path__ + "static/media/nucleo.f0b489a5.woff";